const OPEN_PREVIOUS_CONVERSATIONS_SECTION = 'OPEN_PREVIOUS_CONVERSATIONS_SECTION';
const CLOSE_PREVIOUS_CONVERSATIONS_SECTION = 'CLOSE_PREVIOUS_CONVERSATIONS_SECTION';

const previousConversationSection = (state = false, action) => {
  switch (action.type) {
    case OPEN_PREVIOUS_CONVERSATIONS_SECTION:
      return true;
    case CLOSE_PREVIOUS_CONVERSATIONS_SECTION:
      return false;
    default:
      return state;
  }
};

export default previousConversationSection;
